import { useState } from 'react'
import Dialog from '@mui/material/Dialog'

import Icon from '../../../UI/Icon'
import TopUpPaymentModalInfo from './TopUpPaymentModalInfo'
import TopUpPaymentModalCreditCard from './TopUpPaymentModalCreditCard'
import TopUpPaymentModalCryptocurrencies from './TopUpPaymentModalCryptocurrencies'

import { topUpPaymentMethodIcons, topUpTabs } from '../../../../constants'

const TopUpPaymentModal = ({
  open = false,
  data,
  openCheck = 'data',
  isLoading,
  error,
  resetError,
  onPayment,
  onClose,
  renderInfo,
}) => {
  const [activeTab, setActiveTab] = useState(topUpTabs[0])

  const handleClose = () => {
    onClose()
  }

  const getContent = () => {
    if (activeTab === topUpTabs[0]) {
      return (
        <TopUpPaymentModalCreditCard
          onPayment={onPayment}
          isLoading={isLoading}
          error={error}
          resetError={resetError}
        />
      )
    } else if (activeTab === topUpTabs[1]) {
      return (
        <TopUpPaymentModalCryptocurrencies
          onPayment={onPayment}
          isLoading={isLoading}
          error={error}
          resetError={resetError}
        />
      )
    }
  }

  const topUpTabsContent = topUpTabs.map((topUpTab) => {
    const isActive = activeTab === topUpTab

    return (
      <button
        key={topUpTab}
        className={`flex-1 rounded-[10px] flex items-center justify-center p-[10px] h-[44px] border-[1px] text-base text-primary-100 transition-colors duration-200 ease ${isActive ? 'bg-[#FFE0CA] border-[#F79009] shadow-top-up-tab font-bold' : 'bg-white border-[#FFC9AB]'}`}
        onClick={() => setActiveTab(topUpTab)}
      >
        {topUpTab}
      </button>
    )
  })

  const topUpPaymentMethodIconsContent = topUpPaymentMethodIcons.map((topUpPaymentMethodIcon) => {
    return (
      <img
        key={topUpPaymentMethodIcon}
        src={`/assets/icon/paymentMethods/${topUpPaymentMethodIcon}.svg`}
        alt={topUpPaymentMethodIcon}
        draggable={false}
        className="select-none"
      />
    )
  })

  return (
    <Dialog
      open={openCheck === 'data' ? !!data : open}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'relative xl:!max-w-[1204px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD]',
      }}
    >
      <button className="flex items-center" onClick={handleClose}>
        <Icon name="arrow-left-line" color="#F67443" className="w-[24px] h-[24px]" />

        <span className="ml-[12px] text-sm font-normal text-primary-100">Back</span>
      </button>

      <div className="mt-[10px] w-full flex">
        {renderInfo ? renderInfo() : <TopUpPaymentModalInfo data={data} />}

        <div className="shadow-modal-light flex-1 p-[24px] bg-[#FFF5EE] border-[#FFCA84] border-[1px] rounded-[10px]">
          <span className="text-base font-bold text-primary-100">Select payment method</span>

          <div className="w-full flex items-center mt-[10px] gap-x-[10px] pb-[24px] mb-[24px] border-b-[1px] border-b-[rgba(247,144,9,0.40)]">
            {topUpTabsContent}
          </div>

          {getContent()}

          <div className="mt-[132px] w-full flex items-center justify-center gap-x-[10px]">
            {topUpPaymentMethodIconsContent}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default TopUpPaymentModal
